import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ index, children }) => (
  <p
    data-testid={index ? `chapter-${index}-label` : undefined}
    className="text-[11px] uppercase tracking-[0.3em] font-medium text-[#C69A6B] flex items-center gap-3"
  >
    {index && <span className="font-serif-ed italic text-[#D4A960] text-sm tracking-normal">{index}</span>}
    <span className="h-px w-8 bg-[#D4A960]/60" aria-hidden="true" />
    {children}
  </p>
);
